<template>
  <div class="default-tooltip">
    <div>{{ value ?? "-" }}</div>
  </div>
</template>

<script>
export default {
  name: "DefaultTooltip",
  props: {
    value: {
      type: [String, Number],
      default: "-",
    },
    row: Object,
    column: Object,
  },
};
</script>

<style scoped lang="less"></style>
